import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Navbar from "../../components/Navbar";
import {
  Container,
  Grid,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import PageHeader from "../../components/PageHeader";
import DoneIcon from "@mui/icons-material/Done";
import UserInfoBanner from "../../assets/Images/UserInfoBanner.png";
import ImageUploader from "../../components/ImageUploader";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  serviceProviderInfo,
  createStripeConnectAccount,
  getAllCategories,
} from "../../apis";
import { useNavigate } from "react-router-dom";
const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const ServiceProvider = () => {
  const user = JSON.parse(localStorage.getItem("user-info"));
  const userName = user.fullName;
  const userID = user?.googleId ? user.googleId : user._id;
  const [openSnack, setOpenSnack] = useState(false);

  const [stage, setStage] = useState(1);

  const childDataHandler = (data) => {
    setImages(data);
  };

  const certificatioChildDataHandler = (data) => {
    setCertificationImages(data);
  };
  const photoIDChildDataHandler = (data) => {
    setPhotoIDImages(data);
  };
  const pofChildDataHandler = (data) => {
    setPofImages(data);
  };

  // Personal Information States
  const [accountType, setAccountType] = useState("Personal");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [images, setImages] = useState([]);
  const [traderName, setTraderName] = useState("");
  const [VATNumber, setVATNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  // Personal Information States

  // Skills and expertise states
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [skills, setSkills] = useState([
    { key: 0, label: "AC Management" },
    { key: 1, label: "AC Installation" },
    { key: 2, label: "Dispenser Fixing" },
    { key: 3, label: "General Services" },
    { key: 4, label: "AC Management" },
    { key: 5, label: "AC Installation" },
    { key: 6, label: "Dispenser Fixing" },
    { key: 7, label: "General Services" },
  ]);
  const [mySkill, setMySkill] = useState("");
  const [categoriesData, setCategoriesData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  // Skills and expertise states

  // Certifications states
  const [certificationName, setCertificationName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [institutionName, setInstitutionName] = useState("");
  const [certificationImages, setCertificationImages] = useState([]);
  const [photoIDImages, setPhotoIDImages] = useState([]);
  const [pofImages, setPofImages] = useState([]);
  // Certifications states

  // Payment Information States
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState(null);
  const [securityCode, setSecurityCode] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [doorNumber, setDoorNumber] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("card");

  // Payment Information States

  const navigate = useNavigate();

  useEffect(() => {
    setMySkill("");
  }, [skills]);
  const handleDelete = (chipToDelete) => () => {
    setSkills((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
  };
  const handleChange = (event) => {
    setCategory(event.target.value);
    const filtereddata = categoriesData.filter(
      (item) => item.name == event.target.value
    );
    setSubCategories(filtereddata[0].subCategories);
  };
  const handlePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
  };

  const handleChangeSubCategory = (event) => {
    setSubCategory(event.target.value);
  };

  // const categories = [
  //   { label: "AC Services", value: "AC Services" },
  //   { label: "Cleaning Services", value: "Cleaning Services" },
  //   { label: "Salon and Self Care", value: "Salon and Self Care" },
  //   { label: "Plumbing Services", value: "Plumbing Services" },
  //   { label: "Electrician Services", value: "Electrician Services" },
  //   { label: "Appliances Maintenance", value: "Appliances Maintenance" },
  //   { label: "Packaging and Movers", value: "Packaging and Movers" },
  //   { label: "Pest Control", value: "Pest Control" },
  // ];

  // const subCategories =
  //   category == "AC Services"
  //     ? [
  //         { label: "AC Services", value: "AC Services" },
  //         { label: "AC Management", value: "AC Management" },
  //         { label: "AC Installation", value: "AC Installation" },
  //         { label: "Mounting & Dismounting", value: "Mounting & Dismounting" },
  //         { label: "Dispenser Fixing", value: "Dispenser Fixing" },
  //         { label: "General Services", value: "General Services" },
  //       ]
  //     : category == "Cleaning Services"
  //     ? [{ label: "Cleaning Services", value: "Cleaning Services" }]
  //     : category == "Salon and Self Care"
  //     ? [{ label: "Salon and Self Care", value: "Salon and Self Care" }]
  //     : category == "Plumbing Services"
  //     ? [{ label: "Plumbing Services", value: "Plumbing Services" }]
  //     : category == "Electrician Services"
  //     ? [{ label: "Electrician Services", value: "Electrician Services" }]
  //     : category == "Appliances Maintenance"
  //     ? [{ label: "Appliances Maintenance", value: "Appliances Maintenance" }]
  //     : category == "Packaging and Movers"
  //     ? [{ label: "Packaging and Movers", value: "Packaging and Movers" }]
  //     : category == "Pest Control"
  //     ? [{ label: "Pest Control", value: "Pest Control" }]
  //     : [];

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllCategories();
      setCategoriesData(response.data.categories);
      let arr = [];
      response.data.categories.map((item) => {
        arr.push({ label: item.name, value: item.name });
      });
      setCategories(arr);
    };
    fetchData();
  }, []);

  const submitServiceProviderInfo = async () => {
    const personalInfo = {
      accountType: accountType,
      firstName: firstName,
      lastName: lastName,
      image: images,
      phoneNumber: phoneNumber,
      email: email,
      description: description,
      jobTitle: jobTitle,
      traderName: traderName,
      VATNumber: VATNumber,
      companyName: companyName,
      companyRegistrationNumber: companyRegistrationNumber,
    };

    const expertise = {
      category: category,
      subCategory: subCategory,
      skills: skills,
    };

    const documents = {
      certificationName: certificationName,
      startDate: startDate,
      endDate: endDate,
      institutionName: institutionName,
      certificationImages: certificationImages,
      pofImages: pofImages,
      photoID: photoIDImages,
    };

    const paymentDetails = {
      cardHolderName: cardHolderName,
      cardNumber: cardNumber,
      paymentMethod: paymentMethod,
      securityCode: securityCode,
      expiryDate: expiryDate,
      country: country,
      city: city,
      doorNumber: doorNumber,
      streetAddress: streetAddress,
      postalCode: postalCode,
    };

    if (
      cardHolderName != "" &&
      cardNumber != "" &&
      securityCode != "" &&
      country != "" &&
      city != "" &&
      doorNumber != "" &&
      streetAddress != "" &&
      postalCode != "" &&
      expiryDate != null
    ) {
      const data = await serviceProviderInfo({
        serviceProviderId: userID,
        personalInfo: personalInfo,
        expertise: expertise,
        documents: documents,
        paymentDetails: paymentDetails,
      });
      if (data) {
        let user = JSON.parse(localStorage.getItem("user-info"));
        user.infoFilled = true;
        localStorage.setItem("user-info", JSON.stringify(user));
        navigate("/service-provider/under-review");
      }
    }
  };

  const secondStageHandler = () => {
    if (accountType == "Personal") {
      if (
        firstName != "" &&
        lastName != "" &&
        images.length != 0 &&
        phoneNumber != "" &&
        email != "" &&
        jobTitle != "" &&
        description != ""
      ) {
        setStage(3);
      } else {
        setOpenSnack(true);
      }
    }
    if (accountType == "Sole Trader") {
      if (
        firstName != "" &&
        lastName != "" &&
        images.length != 0 &&
        phoneNumber != "" &&
        email != "" &&
        jobTitle != "" &&
        description != "" &&
        traderName != ""
      ) {
        setStage(3);
      } else {
        setOpenSnack(true);
      }
    }
    if (accountType == "Company") {
      if (
        firstName != "" &&
        lastName != "" &&
        images.length != 0 &&
        phoneNumber != "" &&
        email != "" &&
        jobTitle != "" &&
        description != "" &&
        companyName != "" &&
        companyRegistrationNumber != ""
      ) {
        setStage(3);
      } else {
        setOpenSnack(true);
      }
    }
  };

  const thirdStageHandler = () => {
    if (skills.length != 0 && category != "" && subCategory != "") {
      setStage(4);
    } else {
      setOpenSnack(true);
    }
  };

  const fourthStageHandler = async () => {
    if (
      certificationName != "" &&
      startDate != null &&
      endDate != null &&
      certificationImages.length != 0 &&
      photoIDImages.length != 0 &&
      pofImages.length != 0
    ) {
      const personalInfo = {
        accountType: accountType,
        avgRating: 0,
        firstName: firstName,
        lastName: lastName,
        image: images,
        phoneNumber: phoneNumber,
        email: email,
        description: description,
        jobTitle: jobTitle,
        traderName: traderName,
        VATNumber: VATNumber,
        companyName: companyName,
        companyRegistrationNumber: companyRegistrationNumber,
      };

      const expertise = {
        category: category,
        subCategory: subCategory,
        skills: skills,
      };

      const documents = {
        certificationName: certificationName,
        startDate: startDate,
        endDate: endDate,
        institutionName: institutionName,
        certificationImages: certificationImages,
        pofImages: pofImages,
        photoID: photoIDImages,
      };

      const info = { personalInfo, expertise, documents };
      localStorage.setItem("info", JSON.stringify(info));
      const reponse = await createStripeConnectAccount({ email: email });
      window.location.href = reponse.data.accountLink.url;
      // setStage(5);
    } else {
      setOpenSnack(true);
    }
  };

  const handleClose = () => {
    setOpenSnack(false);
  };

  return (
    <>
      <PageHeader title="Register as Partner" crossIcon />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          variant="filled"
          onClose={handleClose}
        >
          Please fill all of the required information in order to proceed!
        </Alert>
      </Snackbar>
      <Container>
        <Grid container>
          {/* Stepper Start */}
          <Grid item xs={3}>
            <Stack spacing={3}>
              {stage == 1 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">1</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Getting Started
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Getting Started
                  </Typography>
                </Stack>
              )}

              {stage == 2 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">2</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Personal Details
                  </Typography>
                </Stack>
              ) : stage < 2 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">2</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Personal Details
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Personal Details
                  </Typography>
                </Stack>
              )}

              {stage == 3 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">3</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Skilss and Expertise
                  </Typography>
                </Stack>
              ) : stage < 3 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">3</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Skilss and Expertise
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Skilss and Expertise
                  </Typography>
                </Stack>
              )}

              {stage == 4 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">4</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Documents
                  </Typography>
                </Stack>
              ) : stage < 4 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">4</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Documents
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Documents
                  </Typography>
                </Stack>
              )}

              {stage == 5 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">5</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Payment Information
                  </Typography>
                </Stack>
              ) : stage < 5 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">5</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Payment Information
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Payment Information
                  </Typography>
                </Stack>
              )}
            </Stack>
          </Grid>

          {/* Stepper End */}

          <Grid item xs={6}>
            {stage == 1 ? (
              <Box component="div" sx={{ p: 2 }}>
                <img src={UserInfoBanner} />
                <Stack className="mt-16">
                  <Stack>
                    <Typography variant="h4" gutterBottom component="div">
                      Join Amannat as a Service Provider
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography variant="body1" gutterBottom>
                      Hi {userName.toUpperCase()}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Thank you for showing your interest to join Amaanat
                      platform. We are helping professionals like you to promote
                      their digital presence.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Heres how it works:
                    </Typography>
                    <ol>
                      <li>Complete your profile accurately</li>
                      <li>Submit your profile</li>
                      <li>
                        You'll receive an email to let you know if your profile
                        got approved.
                      </li>
                    </ol>
                    <Typography variant="body1" gutterBottom>
                      Our team will be looking forward.
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  className="mt-13"
                  justifyContent="space-between"
                >
                  <Button
                    variant="outlined"
                    style={{ textTransform: "capitalize" }}
                    onClick={() => navigate("/")}
                    className="default-color default-border"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    style={{ textTransform: "capitalize" }}
                    onClick={() => setStage(2)}
                    className="primary-button"
                  >
                    Continue
                  </Button>
                </Stack>
              </Box>
            ) : stage == 2 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Personal Information</h2>
                  <Typography className="registration-label">
                    Type of Account
                  </Typography>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        className={
                          accountType == "Personal"
                            ? "activeRadioContainer"
                            : "radioContainer"
                        }
                        value="Personal"
                        control={<Radio />}
                        label="Personal"
                        checked={accountType == "Personal" ? true : false}
                        onClick={() => setAccountType("Personal")}
                      />
                      <FormControlLabel
                        className={
                          accountType == "Sole Trader"
                            ? "activeRadioContainer"
                            : "radioContainer"
                        }
                        value="Sole Trader"
                        control={<Radio />}
                        label="Sole Trader"
                        checked={accountType == "Sole Trader" ? true : false}
                        onClick={() => setAccountType("Sole Trader")}
                      />
                      <FormControlLabel
                        className={
                          accountType == "Company"
                            ? "activeRadioContainer"
                            : "radioContainer"
                        }
                        value="Company"
                        control={<Radio />}
                        label="Company"
                        checked={accountType == "Company" ? true : false}
                        onClick={() => setAccountType("Company")}
                      />
                    </RadioGroup>
                  </FormControl>
                  {accountType == "Personal" ? (
                    <></>
                  ) : accountType == "Sole Trader" ? (
                    <Stack direction="row" spacing={2}>
                      <Stack className="w-100">
                        <Typography className="registration-label">
                          Trader Name
                        </Typography>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          placeholder="Enter trader name"
                          value={traderName}
                          onChange={(e) => setTraderName(e.target.value)}
                        />
                      </Stack>
                      <Stack className="w-100">
                        <Typography className="registration-label">
                          VAT Number (Optional)
                        </Typography>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          placeholder="Enter VAT number"
                          value={VATNumber}
                          onChange={(e) => setVATNumber(e.target.value)}
                        />
                      </Stack>
                    </Stack>
                  ) : (
                    <>
                      <Stack direction="row" spacing={2}>
                        <Stack className="w-100">
                          <Typography className="registration-label">
                            Company Name
                          </Typography>
                          <TextField
                            required
                            id="outlined-basic"
                            variant="outlined"
                            className="w-100"
                            size="small"
                            placeholder="Enter company name"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                        </Stack>
                        <Stack className="w-100">
                          <Typography className="registration-label">
                            Company Registration Number
                          </Typography>
                          <TextField
                            required
                            id="outlined-basic"
                            variant="outlined"
                            className="w-100"
                            size="small"
                            placeholder="Enter registration number"
                            value={companyRegistrationNumber}
                            onChange={(e) =>
                              setCompanyRegistrationNumber(e.target.value)
                            }
                          />
                        </Stack>
                      </Stack>
                      <Stack className="w-50">
                        <Typography className="registration-label">
                          VAT Number(Optional)
                        </Typography>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          placeholder="Enter VAT number"
                          value={VATNumber}
                          onChange={(e) => setVATNumber(e.target.value)}
                        />
                      </Stack>
                    </>
                  )}
                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        First Name
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Last Name
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </Stack>
                  </Stack>
                  <Stack>
                    <ImageUploader
                      passChildData={childDataHandler}
                      heading="Upload Profile Picture (Please upload professional picture which shows your face)"
                      title="Upload your picture here"
                    />
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Phone Number
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your phone number"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Email Address
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Stack>
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Job Title
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter your current occupation"
                      value={jobTitle}
                      onChange={(e) => setJobTitle(e.target.value)}
                    />
                  </Stack>

                  <Stack>
                    <Typography className="registration-label">
                      About you
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      multiline
                      rows={3}
                      placeholder="Enter some descriptionn about you"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Stack>
                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      type="submit"
                      className="mt-13  default-border default-color"
                      onClick={() => setStage(1)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      className="mt-13 primary-button"
                      onClick={secondStageHandler}
                      style={{ textTransform: "capitalize" }}
                    >
                      Next
                    </Button>
                  </div>
                </Stack>
              </Box>
            ) : stage == 3 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Skills & Expertise</h2>

                  <Stack direction="row" spacing={2}>
                    <FormControl fullWidth size="small">
                      <Typography
                        id="demo-simple-select-label"
                        className="registration-label"
                      >
                        Select Category
                      </Typography>
                      <Select
                        displayEmpty
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={category}
                        onChange={handleChange}
                      >
                        <MenuItem disabled value="">
                          <em>Select Category</em>
                        </MenuItem>
                        {categories.map((item) => (
                          <MenuItem value={item.value}>{item.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                      <Typography
                        id="demo-simple-select-label"
                        className="registration-label"
                      >
                        Select Sub Category
                      </Typography>
                      <Select
                        displayEmpty
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={subCategory}
                        onChange={handleChangeSubCategory}
                      >
                        <MenuItem disabled value="">
                          <em>Select Sub Category</em>
                        </MenuItem>
                        {subCategories.map((item) => (
                          <MenuItem value={item.value}>{item.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>
                  <Stack>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      component="div"
                      className="registration-label"
                    >
                      Select Skills
                    </Typography>
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {skills.map((data) => {
                        return (
                          <ListItem key={data.key}>
                            <Chip
                              label={data.label}
                              onDelete={handleDelete(data)}
                            />
                          </ListItem>
                        );
                      })}
                    </Paper>
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Enter additional skillset
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      value={mySkill}
                      onChange={(e) => setMySkill(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          let obj = {
                            key:
                              skills.length > 0
                                ? skills[skills.length - 1].key + 1
                                : 1,
                            label: mySkill,
                          };
                          setSkills((previous) => [...previous, obj]);
                        }
                      }}
                      placeholder="Enter your other skills here"
                    />
                  </Stack>
                  <Stack spacing={1}></Stack>
                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      className="mt-13  default-color default-border"
                      onClick={() => setStage(2)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      className="mt-13 primary-button"
                      onClick={thirdStageHandler}
                      style={{ textTransform: "capitalize" }}
                    >
                      Next
                    </Button>
                  </div>
                </Stack>
              </Box>
            ) : stage == 4 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Certifications</h2>
                  <Stack>
                    <Typography className="registration-label">
                      Certification Name
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter certification name"
                      value={certificationName}
                      onChange={(e) => setCertificationName(e.target.value)}
                    />
                  </Stack>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack direction="row" spacing={6}>
                      <Stack>
                        <Typography className="registration-label">
                          Start Date
                        </Typography>
                        <DesktopDatePicker
                          size="small"
                          value={startDate}
                          minDate={new Date("2017-01-01")}
                          onChange={(newValue) => {
                            setStartDate(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Stack>
                      <Stack>
                        <Typography className="registration-label">
                          End Date
                        </Typography>
                        <DesktopDatePicker
                          value={endDate}
                          minDate={
                            startDate == null
                              ? new Date("2017-01-01")
                              : startDate
                          }
                          onChange={(newValue) => {
                            setEndDate(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} />}
                          disabled={startDate == null ? true : false}
                        />
                      </Stack>
                    </Stack>
                  </LocalizationProvider>

                  <Stack>
                    <Typography className="registration-label">
                      Institute
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter institution Name"
                      value={institutionName}
                      onChange={(e) => setInstitutionName(e.target.value)}
                    />
                  </Stack>
                  <Stack>
                    <ImageUploader
                      passChildData={certificatioChildDataHandler}
                      heading="Upload Picture (Please upload picture of your certificate)"
                      title="Upload your certificate here"
                    />
                  </Stack>
                  <Stack>
                    <h2 className="mt-13">Documents</h2>
                  </Stack>
                  <Stack>
                    <ImageUploader
                      passChildData={photoIDChildDataHandler}
                      heading="Upload Photo ID"
                      title="Upload picture here"
                    />
                  </Stack>
                  <Stack>
                    <ImageUploader
                      passChildData={pofChildDataHandler}
                      heading="Upload Proof of Address"
                      title="Upload picture here"
                    />
                  </Stack>

                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      type="submit"
                      className="mt-13 default-border default-color"
                      onClick={() => setStage(3)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      className="mt-13 primary-button"
                      onClick={fourthStageHandler}
                      style={{ textTransform: "capitalize" }}
                    >
                      Next
                    </Button>
                  </div>
                </Stack>
              </Box>
            ) : stage == 5 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Select Payment Method</h2>
                  <Stack direction={{ xs: "column", sm: "row" }}>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={paymentMethod}
                      onChange={handlePaymentMethod}
                    >
                      <FormControlLabel
                        value="card"
                        control={<Radio />}
                        label="Debit or Credit Card"
                      />
                      <FormControlLabel
                        value="paypal"
                        control={<Radio />}
                        label="Paypal"
                      />
                    </RadioGroup>
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Card Holder Name
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter card holder name"
                      value={cardHolderName}
                      onChange={(e) => setCardHolderName(e.target.value)}
                    />
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Card Number
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter 16 digit number on your card"
                      value={cardNumber}
                      onChange={(e) => setCardNumber(e.target.value)}
                    />
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Expiry
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="MM/YY"
                        value={expiryDate}
                        onChange={(e) => setExpiryDate(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        CVV
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter CVV"
                        value={securityCode}
                        onChange={(e) => setSecurityCode(e.target.value)}
                      />
                    </Stack>
                  </Stack>
                  <Stack>
                    <h2>Billing Address</h2>
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Country
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter country"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        City
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter City"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </Stack>
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Door/House Number
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter your door or house number"
                        value={doorNumber}
                        onChange={(e) => setDoorNumber(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Street Address
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter street address"
                        value={streetAddress}
                        onChange={(e) => setStreetAddress(e.target.value)}
                      />
                    </Stack>
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Zip or Postal Code
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      size="small"
                      placeholder="Enter your zip or postal code"
                      value={postalCode}
                      style={{ width: "50%" }}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                  </Stack>

                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      type="submit"
                      className="mt-13 default-border default-color"
                      onClick={() => setStage(4)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      className="mt-13 primary-button"
                      onClick={submitServiceProviderInfo}
                      style={{ textTransform: "capitalize" }}
                    >
                      Submit
                    </Button>
                  </div>
                </Stack>
              </Box>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ServiceProvider;
